var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7466 1.83407C23.119 2.20883 23.3864 2.67482 23.5221 3.18541C24.0239 5.06995 24.0239 8.99996 24.0239 8.99996C24.0239 8.99996 24.0239 12.93 23.5221 14.8145C23.3864 15.3251 23.119 15.7911 22.7466 16.1658C22.3743 16.5406 21.91 16.811 21.4003 16.95C19.5239 17.4545 12.0239 17.4545 12.0239 17.4545C12.0239 17.4545 4.52393 17.4545 2.64756 16.95C2.13786 16.811 1.67358 16.5406 1.30121 16.1658C0.928842 15.7911 0.661431 15.3251 0.525744 14.8145C0.0239258 12.93 0.0239258 8.99996 0.0239258 8.99996C0.0239258 8.99996 0.0239258 5.06995 0.525744 3.18541C0.661431 2.67482 0.928842 2.20883 1.30121 1.83407C1.67358 1.4593 2.13786 1.18891 2.64756 1.04996C4.52393 0.54541 12.0239 0.54541 12.0239 0.54541C12.0239 0.54541 19.5239 0.54541 21.4003 1.04996C21.91 1.18891 22.3743 1.4593 22.7466 1.83407ZM15.8421 9.00003L9.56934 5.4314V12.5687L15.8421 9.00003Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.9157af0af0cc6a67e8c0e9688f683ce8.svg";
export { ForwardRef as ReactComponent };